$(document).ready(function() {
    	
  	var pickupLabel = "In-Store Pickup On Campus?"; // the text of the label
	var pickupVariantId = 8241296867417; // the variant ID of the local pickup product
  	var buttonArea = $('form.cart .instore__pickup'); // where to insert the option 
 
  	Shopify.getCart(function(cart) {
    	var inCart = false;
    	$.each(cart.items, function(index, item) {
      		if (item.variant_id == pickupVariantId) {
        		inCart = true;
        		return false;
      		}
    	});
    	buttonArea.append('<label for="local-pickup"><input id="local-pickup" type="checkbox"' + (inCart ? ' checked' : '') + ' /> ' + pickupLabel + '</label>');
  	});
  
      
  Shopify.onCartUpdate = function(cart) {
    var inCart = false;
    var otherItems = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == pickupVariantId) {
        inCart = true;
      } else {
        otherItems = true;
      }
    });
    if(inCart && !otherItems) {
      Shopify.clear(function() {
        location.reload();
      });
    }
    if(!inCart) {
      $('#local-pickup').prop('checked', false);
    }
  };

  	buttonArea.on('change', '#local-pickup', function() {
    	if ($(this).is(':checked')) {
      		Shopify.addItem(pickupVariantId, 1, function(item) {
        		location.reload();
      		});
    	} else {
      		Shopify.changeItem(pickupVariantId, 0, function(cart) {
        		location.reload();
      		});
    	}
  	});

  
});